import Splide from '@splidejs/splide';

$(document).ready(function(){
  testimonialsSlider();
  sliderHeight();
})

$(window).on('resize', function(){
  sliderHeight();
})

function adjustSliderHeight(splide) {
  var currentSlide = splide.Components.Elements.slides[splide.index];
  var newHeight = currentSlide.querySelector('.testimonial').offsetHeight;
  splide.root.style.height = newHeight + 'px';
}

function testimonialsSlider() {
  var elms = $('.testimonials-slider');
  for (var i = 0, len = elms.length; i < len; i++) {
    let splide = new Splide(elms[i], {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: false,
      padding: { right: '5rem' },
      // autoplay: true,
      breakpoints: {
        991: {
          padding: { right: '0rem' },
        },
      }
    }).mount();

    // Call the function on initial load
    adjustSliderHeight(splide);

    splide.on('move', function () {
      adjustSliderHeight(splide);
    });
  }
}

function sliderHeight() {
  if($(window).width() > 991) {
    $('.testimonial__info').each(function() {
      var sliderHeight = $(this).height();
      $(this).siblings('.testimonial__images').children('.testimonial__image').height(sliderHeight+60);
    })
  }
}
